import React from 'react';
import { useEffect, useState, useContext } from 'react';
import { Cartcontext } from '../../context/Context';
import './Footer.css';
import FollowUs from './FollowUs';
import { useNavigate } from 'react-router-dom';

function Footer() {
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);

    const Globalstate = useContext(Cartcontext);
    const { storeData } = Globalstate;

    useEffect(() => {
        setTimeout(() => {
            setLoaded(true);
        }, 1000);
    }, []);

    const d = new Date();
    let year = d.getFullYear();

    const footerTopStyle = {
        backgroundColor:
            storeData && storeData.color
                ? storeData.color.FooterColor
                : '#ffffff',
        color:
            storeData && storeData.color
                ? storeData.color.FooterTextColor
                : '#000000',
        transition: 'opacity 0.5s ease-in-out',
        opacity: loaded ? 1 : 0,
    };

    const quikLinks = [
        { name: 'Privacy Policy', url: '/link/privacy' },
        { name: 'Terms & Conditions', url: '/link/terms' },
        { name: 'Return Policy', url: '/link/return' },
        { name: 'Shipping Policy', url: '/link/shipping' },
    ];
    return (
        <>
            <div
                className={`footer-Top ${loaded ? 'loaded' : ''}`}
                style={footerTopStyle}
            >
                <div className="footer-Top-box">
                    <h3
                        style={{
                            color:
                                storeData && storeData.color
                                    ? storeData.color.FooterTextColor
                                    : '#000000',
                        }}
                    >
                        Quick Links
                    </h3>
                    <ul>
                        {quikLinks &&
                            quikLinks.map((data, index) => {
                                return (
                                    <li
                                        key={index}
                                        onClick={() => navigate(data.url)}
                                        style={{
                                            color:
                                                storeData && storeData.color
                                                    ? storeData.color
                                                          .FooterTextColor
                                                    : '#000000',
                                        }}
                                    >
                                        {data.name}
                                    </li>
                                );
                            })}
                    </ul>
                </div>
                <div className="footer-Top-box">
                    <h3
                        style={{
                            color:
                                storeData && storeData.color
                                    ? storeData.color.FooterTextColor
                                    : '#000000',
                        }}
                    >
                        Contact Us
                    </h3>
                    <ul>
                        <li
                            style={{
                                color:
                                    storeData && storeData.color
                                        ? storeData.color.FooterTextColor
                                        : '#000000',
                            }}
                        >
                            {storeData ? storeData.store : ''}
                        </li>
                        <li
                            style={{
                                color:
                                    storeData && storeData.color
                                        ? storeData.color.FooterTextColor
                                        : '#000000',
                            }}
                        >
                            Address: {storeData ? storeData.Address : ''}
                        </li>
                        <li
                            style={{
                                color:
                                    storeData && storeData.color
                                        ? storeData.color.FooterTextColor
                                        : '#000000',
                            }}
                        >
                            Email Us:{' '}
                            <a
                                href={`mailto:${
                                    storeData ? `${storeData.Email}` : ''
                                }`}
                                style={{
                                    color:
                                        storeData && storeData.color
                                            ? storeData.color.FooterTextColor
                                            : '#000000',
                                }}
                            >
                                {storeData ? `${storeData.Email}` : ''}
                            </a>{' '}
                        </li>
                        <li
                            style={{
                                color:
                                    storeData && storeData.color
                                        ? storeData.color.FooterTextColor
                                        : '#000000',
                            }}
                        >
                            Call Us:{' '}
                            <a
                                href={`tel:${
                                    storeData ? storeData.number : ''
                                }`}
                                style={{
                                    color:
                                        storeData && storeData.color
                                            ? storeData.color.FooterTextColor
                                            : '#000000',
                                }}
                            >
                                {storeData ? storeData.number : ''}
                            </a>{' '}
                        </li>
                    </ul>
                </div>
                <FollowUs storeData={storeData} />
            </div>
            {storeData && storeData.color ? (
                <div
                    className={`footer ${loaded ? 'loaded' : ''}`} // Apply transition class
                    style={{
                        padding: '10px',
                        background: storeData.color.FooterColor,
                        color: storeData.color.FooterTextColor,
                        fontFamily: 'Kalam cursive',
                        transition: 'opacity 0.5s ease-in-out', // Add transition for opacity
                        opacity: loaded ? 1 : 0, // Control opacity based on loading state
                        borderTop: '1px solid rgba(204, 204, 204, 0.16)',
                    }}
                >
                    <div className="deDesign-and-Developeds">
                        Copyright {year} ©{' '}
                        <a
                            style={{
                                color: storeData.color.FooterTextColor,
                                fontSize: '19px',
                            }}
                            href={`https://${
                                storeData ? storeData.domain : ''
                            }`}
                            target="blank"
                        >
                            {storeData ? storeData.domain : ''}
                        </a>{' '}
                        - Powered By{' '}
                        <a
                            style={{
                                color: storeData.color.FooterTextColor,
                                fontSize: '19px',
                            }}
                            href="https://ecomtechbd.com"
                            target="blank"
                        >
                            EcomTech
                        </a>
                    </div>
                </div>
            ) : (
                ''
            )}
        </>
    );
}

export default Footer;
